import { CSSProperties, cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { memo } from 'react';
import { locales } from '../../locales/en';
import IconGroup from '../Icons/Group';
import IconViewers from '../Icons/Viewers';
import "./CounterViewers.linaria.module.css!=!./CounterViewers?./CounterViewers.linaria.module.css?css=H4sIAAAAAAAAA3WQ0XKCMBBF3/sVPtaHOGDa0okfw4SwwWDYYLIKyvTfO6IgUPt4z967e2c3IcYmHD+wy02orbwI1kB2MMQy1+6WTFuYwCr0YGrsDVM3y40HRcah8K7ZDZkFfuV81mC1VAehAAn8c8MMPszlKZDRF6YcEiAN43/wkJLWFMgMQRWWo9v1fvzn/Iy+2PDztpFUpbJKD1mC52t3S4l44MU1jW2ScekXsqukLwwyC5oEr9shoEKaaSycnqtOOyTWgCn2JD6jaNzPH3fnqrMGge3v9rFMYtOYB5dD3ilnnRdn6d9Z/y4vAzGCltZjke805gnocruQ9yrBXOGRH/V68o14y/mXU/d3RKtoJU/kpkXKFrOifF3EKIfhtu0X8VLAzbcCAAA="
interface ICounterViewers {
  className?: string;
  color?: string;
  diff?: number;
  group?: boolean;
  highContrast?: boolean;
  size?: number;
  viewers?: number;
}
const StyledRoot = /*#__PURE__*/styled('div')({
  name: "StyledRoot",
  class: "s1nwsq4n",
  propsAsIs: false
});
const viewersStyle = "atm_am_kb7nvz atm_gz_1l7b3ar atm_cs_bfngof atm_g3_kb7nvz atm_7l_13soded atm_c8_137efj2";
const iconStyles = "atm_am_12336oc atm_7l_1jxnbgj";
const highContrastStyles = "atm_7l_13soded";
const CounterViewers = memo((props: ICounterViewers) => {
  const {
    color,
    highContrast,
    size = 0.8,
    // styleOverrides,
    className,
    viewers,
    group,
    diff
  } = props;
  const resolvedStyles = cx(iconStyles, highContrast && highContrastStyles);
  const labelStyles = cx(viewersStyle);
  const Icon = group ? IconGroup : IconViewers;
  if (typeof viewers !== 'number') return null;
  return <StyledRoot title={locales.modelTile.viewers}>
            <Icon size={size} color={color} className={cx(resolvedStyles, className ? className : null)} />
            <div style={{
      '--font-size': `${12 * size / 0.8}px`
    } as CSSProperties} data-testid="SearchResultCell__ViewersCount" className={cx(labelStyles, className ? className : null)}>
                {viewers}
                {diff && <span> +{diff}/min</span>}
            </div>
        </StyledRoot>;
});
export default CounterViewers;